{
  "_meta": {
    "project": "KAGRA Budget Optimization & Computing Transformation",
    "system_name": "KAGRA Budget Allocation Interactive Decision Platform",
    "version": "1.0.0",
    "last_updated": "2026-11-06",
    "supported_locales": [
      "zh-TW",
      "en",
      "ja"
    ],
    "default_locale": "zh-TW",
    "currency_base": {
      "currency": "TWD",
      "symbol": "NT$",
      "total_budget": 1500000.0,
      "usd_equivalent_approx": 46000.0,
      "jpy_equivalent_approx": 7000000.0
    },
    "governance_and_compliance": {
      "pi": "Prof. Henry Tsz-King Wong (王子敬教授), ASIoP",
      "infrastructure_partner": "ASGC (Academia Sinica Grid-computing Centre)",
      "international_body": "KAGRA Collaboration (KSC / DAC / CSWG)",
      "policy_reference": "KAGRA DocDB 17608 (New Policy for KAGRA Data Retention, approved 2026-10-29)",
      "pricing_reference": "NSTCCore / ASGC Official Tariffs (2026)",
      "citation_standard": "Computed at Academia Sinica (AS)"
    }
  },
  "zh-TW": {
    "system": {
      "title": "KAGRA 經費配置與算力轉型互動式決策平台",
      "subtitle": "中研院物理所 (ASIoP) × 網格計算中心 (ASGC) 國際科學基礎設施戰略投資模型",
      "tagline": "以 150 萬年度總預算，解鎖 1.0 PB 規範存檔與 65%+ 專屬 GPU 重力波算力引擎",
      "strategic_declaration": "本平台由中研院物理所（ASIoP）王子敬教授主持，攜手 ASGC 網格中心，為 KAGRA 國際重力波合作計畫量身打造下一代數據與算力基礎設施。總投資預算嚴謹錨定於 NT$ 1,500,000 / 年（約 46,000 USD / 年）。轉型核心全面實踐「儲存減負、算力騰飛」：依據 2026 年 10 月 29 日 KSC 大會全場一致通過之新資料保留政策（DocDB 17608），將冷資料儲存封頂於 1.0 PB 磁帶，徹底解除歷史雜訊與 CephFS 熔斷危機；磁碟縮減至 200 TB 高效工作快取；投資 10~20 TB 建立 OSDF 亞太分發樞紐；並將主力經費（約 NT$ 980,000，佔 65% 以上）集中灌注於專案專用 GPU 高效能算力池，直接攻克 LVK 全球 GPU 匱乏瓶頸，產出國際頂尖科學成果並標註『Computed at AS』。",
      "badges": {
        "tape_cap": "1.0 PB 磁帶封頂",
        "retention_policy": "DocDB 17608 合規",
        "disk_cache": "200 TB 高速快取",
        "osdf_hub": "OSDF 亞太分發樞紐",
        "gpu_priority": "65%+ 專屬 GPU 算力",
        "credit_ack": "Computed at AS 成果標記"
      }
    },
    "modules": {
      "tape_archive": {
        "id": "tape_archive",
        "name": "磁帶歸檔池 (Tape Archive Pool)",
        "category": "長久冷儲存",
        "badge": "合規與永久保存",
        "pricing_tag": "NT$ 300 / TB / 年",
        "description": "作為全量核心科學資料的安全底座，嚴格執行 1.0 PB（1,000 TB）磁帶保證配額。全案深度契合 2026-10-29 KSC 線上大會通過之 DocDB 17608 政策：永久保存科學觀測期（Observing Periods）資料，每半年經 CSWG 清單審查刪除非觀測期過渡工程數據，達成零風險長久冷歸檔。",
        "specs_summary": "1,000 TB 保證額度 | 年耗費 NT$ 300,000 (佔比 20.0%)",
        "technical_details": "採用 IBM/Spectra 企業級 LTO 磁帶庫，離線冷資料物理隔離防竄改，支援批次 staging 還原至 CephFS 快取池。"
      },
      "cephfs_cache": {
        "id": "cephfs_cache",
        "name": "CephFS 工作快取池 (CephFS Scratch & Cache Pool)",
        "category": "高速磁碟工作區",
        "badge": "高吞吐計算快取",
        "pricing_tag": "NT$ 1,000 / TB / 年",
        "description": "磁碟儲存空間由歷史的近 800 TB 大幅精簡至 200 TB。定位徹底轉變為『純計算工作快取』，專供正在執行的 GPU/CPU 計算作業與暫存分析管線，解除 ASGC CephFS 79% 儲存熔斷危機，提供極高微秒級 POSIX 吞吐能力。",
        "specs_summary": "200 TB 高速快取 | 年耗費 NT$ 200,000 (佔比 13.3%)",
        "technical_details": "全 Ceph 分散式儲存架構，原生掛載於 ASGC HPC 計算節點與 Slurm 排程環境，消除跨節點 I/O 延遲。"
      },
      "osdf_hub": {
        "id": "osdf_hub",
        "name": "OSDF 亞太分發樞紐 (OSDF Asia-Pacific Distribution Hub)",
        "category": "全球科學數據聯網",
        "badge": "IGWN 跨國分發節點",
        "pricing_tag": "磁碟 NT$ 1,000/TB/年 + CPU 牌價",
        "description": "配置 10~20 TB 專用快取磁碟與 4~8 vCPU 代理伺服器，作為 Open Science Data Federation (OSDF) 於亞太地區的次級關鍵節點。直接快取東大柏校區 Origin 數據（約 8.2 TB），大幅緩解跨太平洋國際鏈路頻寬壓力，年投資僅約 1~2 萬元，以極小預算撬動跨國協同效應。",
        "specs_summary": "10~20 TB 快取 + 4~8 vCPU | 年耗費 NT$ 11,752 ~ 23,504 (佔比約 0.8% ~ 1.6%)",
        "technical_details": "整合 Pelican / XRootD OSDF 代理協議，與美國 OSG (Open Science Grid) 及日本東大柏校區無縫互通。"
      },
      "compute_pool": {
        "id": "compute_pool",
        "name": "GPU / CPU 高效能算力池 (Core Compute Engine)",
        "category": "科學分析運算核心",
        "badge": "戰略核心驅動",
        "pricing_tag": "動態預算平衡 (約 NT$ 98 萬，佔比 >65%)",
        "description": "本轉型方案之靈魂。將節省下來之龐大儲存預算集中灌注於專案專用運算資源，配置 10~24 張頂級 GPU（A100, L40S, RTX 4090）及 650~1,250 核心高效能 CPU。拒絕無名公用佇列，鎖定 Sawada / RESCEU 即時搜尋及參數估計專案專用，產出論文一律標註『Computed at AS』。",
        "specs_summary": "專屬 GPU 加速池 + 千核 CPU 叢集 | 年耗費約 NT$ 976,496 ~ 988,248 (佔比 >65.1%)",
        "technical_details": "支援 NVIDIA CUDA 12+, Tensor Core FP16/BF16/FP64, Apptainer/Singularity 容器環境與 CVMFS 軟體散播。"
      }
    },
    "presets": {
      "preset_1_flagship_gpu": {
        "id": "preset_1",
        "key": "flagship_gpu",
        "name": "方案一：旗艦 GPU 專案專用型",
        "sub_name": "Sawada / RESCEU 即時搜尋加速專案",
        "tagline": "頂級雙精度與張量算力全力加持，專攻 O5 低延遲機器學習推論管線",
        "target_scenario": "極致專案導向。專門提供給東京大學 Sawada 助教、Alvin 團隊在 RESCEU / SPIIR 進行之 O5 low-latency 即時機器學習搜尋管線。針對 LVK 全球 GPU 最嚴峻短缺點進行定點突破，確保在 GW 警報發布時享有最優先算力，產出標誌性科研成果。",
        "highlights": [
          "配置 16 張 NVIDIA A100 (80GB) 頂級旗艦卡全年常駐",
          "提供高達 1,280 GB 頂規 HBM2e 顯存總量",
          "搭配 648 核心 AMD EDR2 (Zen 5c) 最新架構伴隨 CPU",
          "計算經費達 NT$ 988,248 (佔總額 65.9%)，直接解鎖最高能見度"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "10 TB + 4 vCPU EDR2",
          "gpu": "16 卡 NVIDIA A100 (80GB)",
          "cpu": "648 核心 AMD EDR2 (Zen 5c)"
        }
      },
      "preset_2_balanced_flagship": {
        "id": "preset_2",
        "key": "balanced_flagship",
        "name": "方案二：均衡旗艦型",
        "sub_name": "即時推論 ＋ 千核大規模離線參數估計 (PE)",
        "tagline": "黃金分割比例，兼顧即時重力波警戒推論與龐大貝氏參數估計",
        "target_scenario": "全面平衡型。以 10 張 A100 (80GB) 建立常駐即時推論佇列，並將剩餘經費極大化配置多達 1,250 核心 AMD EDR2 CPU。完美兼顧短週期低延遲推論與長期重度消耗 CPU 的 Bilby / LALInference 蒙地卡羅馬可夫鏈 (MCMC) 參數估計作業。",
        "highlights": [
          "10 張 A100 (80GB) 提供 800 GB 大顯存即時推論底座",
          "突破千核：高達 1,250 核心高效能 AMD Zen 5c CPU",
          "每年提供 45.6 萬 core-days 巨量離線網格運算能量",
          "經費利用率 100% 精準平衡，無任何資金閒置"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "10 TB + 8 vCPU EDR2",
          "gpu": "10 卡 NVIDIA A100 (80GB)",
          "cpu": "1,250 核心 AMD EDR2 (Zen 5c)"
        }
      },
      "preset_3_high_density": {
        "id": "preset_3",
        "key": "high_density",
        "name": "方案三：高卡數高性價比型",
        "sub_name": "L40S / RTX 4090 巨量並發與多青年團隊支持",
        "tagline": "卡數翻倍暴增至 24 卡，以極致性價比支援多管線同時平行作業",
        "target_scenario": "高並發多團隊型。採用新世代 Ada Lovelace 架構之 12 卡 L40S (45GB) 與 12 卡 RTX 4090 (24GB)，合計高達 24 張加速卡，將 ASGC 原有對外 7 卡規模翻數倍！專門提供給神田教授提名之青年科學家（酒井一樹、押野翔一、Marco）及多組 DetChar/CBC 團隊同時調度。",
        "highlights": [
          "總卡數達 24 張高階 GPU（12× L40S 45GB + 12× RTX 4090 24GB）",
          "總顯存達 828 GB，支援多組機器學習模型平行訓練",
          "升級 20 TB OSDF 亞太分發樞紐，跨國數據調閱近乎零延遲",
          "保留 949 核心 CPU 支撐資料前處理與特徵工程"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "20 TB + 8 vCPU EDR2",
          "gpu": "12 卡 L40S (45GB) + 12 卡 RTX 4090 (24GB)",
          "cpu": "949 核心 AMD EDR2 (Zen 5c)"
        }
      },
      "preset_4_full_stack_package": {
        "id": "preset_4",
        "key": "full_stack_package",
        "name": "方案四：完整科學套裝型",
        "sub_name": "頂級混合 GPU ＋ 千核常駐 ＋ 20 TB OSDF 旗艦樞紐",
        "tagline": "全功能旗艦配置，一站式構築 KAGRA 亞太第一級數據與算力中心",
        "target_scenario": "一站式全能型。專為中研院作為 KAGRA 亞太核心 Tier-1 運維標準打造：配備完整 20 TB OSDF 亞太分發節點、6 卡 A100 (80GB) 旗艦雙精度卡、8 卡 L40S (45GB) 高效能推論卡，以及 1,170 核心超大規模 CPU 叢集，滿足從國際數據鏡像、即時搜尋到深度物理參數估計的全流程需求。",
        "highlights": [
          "異質混合 GPU：6 卡 A100 (80GB) ＋ 8 卡 L40S (45GB) 合計 840 GB 顯存",
          "千核規模：1,170 核心 AMD EDR2 CPU 保持長期高通量分析",
          "完整 20 TB OSDF + 8 vCPU 亞太快取樞紐，鏈路負載降低 80%",
          "全面契合 KAGRA 國際合作組對台灣節點之最高期待"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "20 TB + 8 vCPU EDR2",
          "gpu": "6 卡 A100 (80GB) + 8 卡 L40S (45GB)",
          "cpu": "1,170 核心 AMD EDR2 (Zen 5c)"
        }
      }
    },
    "hardware_catalog": {
      "storage_tiers": {
        "tape": {
          "name": "LTO 企業級磁帶庫 (Tape Archive)",
          "spec": "高密度磁帶盒 / 物理隔離 / 零耗能保存",
          "unit_price_display": "NT$ 300 / TB / 年",
          "unit_type": "TB / 年",
          "role_desc": "大容量歷史冷資料與觀測期正式資料長久合規保存"
        },
        "cephfs": {
          "name": "CephFS 分散式磁碟快取 (Scratch Storage)",
          "spec": "NVMe/SAS 混合分散式架構 / POSIX 相容",
          "unit_price_display": "NT$ 1,000 / TB / 年",
          "unit_type": "TB / 年",
          "role_desc": "活躍分析工作區與高效能快取，支援隨機高並發 I/O"
        },
        "osdf_cache": {
          "name": "OSDF 亞太快取磁碟 (Federation Cache)",
          "spec": "專用 XRootD / Pelican Proxy 緩衝存儲",
          "unit_price_display": "NT$ 1,000 / TB / 年",
          "unit_type": "TB / 年",
          "role_desc": "跨國 Open Science 數據鏡像與亞太高速分發"
        }
      },
      "gpu_models": {
        "A100": {
          "name": "NVIDIA A100 Tensor Core",
          "vram": "80 GB HBM2e",
          "architecture": "Ampere (HPC 頂級旗艦)",
          "rate_daily": "NT$ 120.0 / 卡·日",
          "rate_yearly": "NT$ 43,800 / 卡·年",
          "best_for": "頂級 FP64 數值模擬、大規模張量運算、超大模型訓練"
        },
        "L40S": {
          "name": "NVIDIA L40S Accelerator",
          "vram": "45 GB GDDR6 (ECC)",
          "architecture": "Ada Lovelace (次世代通用專業卡)",
          "rate_daily": "NT$ 70.0 / 卡·日",
          "rate_yearly": "NT$ 25,550 / 卡·年",
          "best_for": "Transformer 重力波推論、高吞吐機器學習、高並發管線"
        },
        "RTX4090": {
          "name": "NVIDIA GeForce RTX 4090",
          "vram": "24 GB GDDR6X",
          "architecture": "Ada Lovelace (極致性價比旗艦)",
          "rate_daily": "NT$ 60.0 / 卡·日",
          "rate_yearly": "NT$ 21,900 / 卡·年",
          "best_for": "高並發單精度 FP32 計算、即時過濾匹配、青年團隊快速迭代"
        },
        "RTX3090": {
          "name": "NVIDIA GeForce RTX 3090",
          "vram": "24 GB GDDR6X",
          "architecture": "Ampere (高密度工作站卡)",
          "rate_daily": "NT$ 40.0 / 卡·日",
          "rate_yearly": "NT$ 14,600 / 卡·年",
          "best_for": "即時低延遲推論池、特徵擷取、中小型機器學習任務"
        },
        "V100": {
          "name": "NVIDIA Tesla V100",
          "vram": "24 GB / 32 GB HBM2",
          "architecture": "Volta (經典資料中心卡)",
          "rate_daily": "NT$ 35.0 / 卡·日",
          "rate_yearly": "NT$ 12,775 / 卡·年",
          "best_for": "既有 CUDA 穩定管線、FP64/FP32 數值積分驗證"
        },
        "B6000": {
          "name": "NVIDIA RTX PRO 6000",
          "vram": "96 GB GDDR6 (ECC)",
          "architecture": "Ada Lovelace (海量顯存專業旗艦)",
          "rate_daily": "NT$ 127.0 / 卡·日",
          "rate_yearly": "NT$ 46,355 / 卡·年",
          "best_for": "超巨量波形模板比對、無縫容納百萬維度複雜參數狀態"
        },
        "P100": {
          "name": "NVIDIA Tesla P100",
          "vram": "16 GB HBM2",
          "architecture": "Pascal (經濟型資料中心卡)",
          "rate_daily": "NT$ 8.0 / 卡·日",
          "rate_yearly": "NT$ 2,920 / 卡·年",
          "best_for": "基礎教學、管線語法測試、輕量輔助除錯"
        }
      },
      "cpu_models": {
        "EDR2": {
          "name": "AMD EPYC 9645 (Zen 5c)",
          "cores_per_node": "96 核心 / 節點",
          "rate_daily": "NT$ 1.2 / 核·日",
          "rate_yearly": "NT$ 438.0 / 核·年",
          "best_for": "推薦主力：次世代最高能效比、高並發格點搜尋與參數估計"
        },
        "intel_g4": {
          "name": "Intel Xeon Gold 6448H",
          "cores_per_node": "128 核心 (Sapphire Rapids)",
          "rate_daily": "NT$ 1.4 / 核·日",
          "rate_yearly": "NT$ 511.0 / 核·年",
          "best_for": "強大單核效能、Intel MKL 向量優化科學數學庫"
        },
        "EDR1": {
          "name": "AMD Genoa 9654",
          "cores_per_node": "192 核心 @ 2.4GHz (Zen 4)",
          "rate_daily": "NT$ 1.2 / 核·日",
          "rate_yearly": "NT$ 438.0 / 核·年",
          "best_for": "穩定主力叢集、大容量記憶體密集型分析工作"
        },
        "HDR1": {
          "name": "AMD Rome 7662",
          "cores_per_node": "128 核心 @ 2.0GHz (Zen 2)",
          "rate_daily": "NT$ 1.0 / 核·日",
          "rate_yearly": "NT$ 365.0 / 核·年",
          "best_for": "高性價比巨量離線批次運算、長週期低優先級作業"
        }
      }
    },
    "calculator": {
      "title": "互動式預算動態精算台",
      "subtitle": "自由調整儲存與算力配比，即時檢驗預算邊界與資源交付規模",
      "labels": {
        "total_budget": "年度總投資預算",
        "allocated_budget": "已配置預算總額",
        "remaining_balance": "剩餘待配置資金",
        "budget_utilization": "預算總執行率",
        "storage_subtotal": "基礎儲存與快取支出",
        "compute_subtotal": "核心運算資源總支出",
        "gpu_share": "GPU 算力佔比",
        "cpu_share": "CPU 算力佔比",
        "osdf_share": "OSDF 快取佔比",
        "tape_quota": "磁帶歸檔額度",
        "disk_quota": "CephFS 工作快取",
        "osdf_capacity": "OSDF 快取磁碟",
        "osdf_cpu": "OSDF 節點 vCPU",
        "gpu_count": "GPU 總卡數",
        "total_vram": "總顯示卡記憶體 (VRAM)",
        "cpu_cores": "CPU 總核心數",
        "currency_twd": "新台幣 (NTD)",
        "currency_usd": "美元 (USD)",
        "currency_jpy": "日圓 (JPY)"
      },
      "status_messages": {
        "optimal": {
          "type": "success",
          "title": "預算配置最佳 (Optimal)",
          "text": "資金配置精準達到 100% 總額度，無任何資源浪費，各模組運作最優化。"
        },
        "surplus": {
          "type": "info",
          "title": "尚有未分配額度 (Surplus Available)",
          "text": "目前尚有剩餘資金，建議點擊「自動補滿 CPU」或增加 GPU 卡數以最大化科研產能。"
        },
        "deficit": {
          "type": "danger",
          "title": "超出預算上限 (Budget Exceeded)",
          "text": "配置已超出 NT$ 1,500,000 天花板！請調降 GPU 卡數或減少 CPU 核心數以符合經費規範。"
        },
        "gpu_target_met": {
          "type": "success",
          "title": "轉型指標達成 (GPU Priority Target Met)",
          "text": "GPU 算力支出已達總算力池之 65% 以上（約 NT$ 98 萬），完美契合解決 LVK 算力荒之戰略方針。"
        },
        "gpu_target_low": {
          "type": "warning",
          "title": "建議提升 GPU 佔比 (GPU Share Below Target)",
          "text": "當前 GPU 佔比偏低。依王老師與日方首長共識，建議將主力經費（>65%）配置於專案專用 GPU。"
        },
        "retention_compliant": {
          "type": "success",
          "title": "完全合規 DocDB 17608 資料保留政策",
          "text": "磁帶設定 1.0 PB 封頂並搭配定期非觀測期數據精簡清單，徹底解除 ASGC 磁碟空間危機。"
        }
      },
      "controls": {
        "apply_preset": "套用推薦預設方案",
        "auto_fill_cpu": "一鍵利用剩餘預算補滿 CPU",
        "reset_defaults": "重設為預設配置",
        "select_gpu_model": "選擇 GPU 加速卡型號",
        "select_cpu_model": "選擇 CPU 處理器架構",
        "adjust_tape_slider": "調整磁帶歸檔容量 (TB)",
        "adjust_disk_slider": "調整 CephFS 工作快取 (TB)",
        "adjust_osdf_slider": "調整 OSDF 快取容量 (TB)",
        "auto_fill_hint": "系統將依據您當前剩餘資金，自動計算可購買之最大整數 CPU 核心數。"
      }
    },
    "actions": {
      "export_json": "匯出配置資料 (JSON)",
      "export_summary_md": "匯出決策摘要 (Markdown)",
      "copy_share_url": "複製專案配置分享連結",
      "copied_notification": "專案分享連結已成功複製至剪貼簿！",
      "exported_notification": "配置檔案已成功下載至您的裝置！",
      "view_methodology": "查閱完整經費方法論 (v9.3)",
      "contact_pi": "聯絡專案辦公室 (ASIoP / ASGC)"
    },
    "footnotes": {
      "tariff_basis": "經費單價基準：全面依據國家科學技術委員會核心設施（NSTCCore / ASGC）最新官方公開牌價（2026 年最新公佈）。實際合作合約可透過王老師與 ASGC 嚴漢偉主任進一步洽商大宗預約折扣。",
      "retention_policy_basis": "資料保留合規：磁帶 1.0 PB 封頂及 200 TB 快取架構，完全遵循 2026 年 10 月 29 日 KAGRA 科學合作組（KSC）全體大會一致通過之全新資料保留政策（DocDB 17608），僅永久保留科學觀測期正式數據，每半年依 CSWG 核定清單刪除無效數據。",
      "attribution_clause": "學術致謝要求：使用本專案專案專用 GPU/CPU 算力所產出之各項重力波搜尋、參數估計或儀器機器學習論文，必須於論文致謝中明確標記『Computed at Academia Sinica (AS)』，並引用 ASGC 算力資助代碼。",
      "currency_conversion": "貨幣匯率說明：基準預算為新台幣 NT$ 1,500,000 / 年。對外折合約 46,000 美元（USD）或 700 萬日圓（JPY），數值僅供國際交流參考，正式執行與帳務核銷一律採新台幣結算。",
      "binary_capacity_standard": "容量規範聲明：為兼顧硬體計費與科學計算習慣，本模型中磁碟與磁帶在官方牌價計算採十進位制（1 TB = 10^12 Bytes），在底層計算節點掛載時採二進位制（1 TiB = 1024^4 Bytes），整體誤差在 ±2.4% 容許區間內。"
    },
    "ui": {
      "presets_heading": "四大官方推薦預設方案一鍵套用",
      "modules_heading": "四大核心資源板塊動態配置",
      "analytics_heading": "即時決策儀表板與能見度驗證",
      "kpi_total_compute": "總算力交付規格",
      "kpi_gpu_target": "戰略目標: >65%",
      "gpu_alloc_heading": "GPU 加速卡分配 (各型號獨立配置)",
      "cpu_arch_heading": "選擇 CPU 處理器架構",
      "cpu_cores_slider": "CPU 保證計算核心數",
      "tape_slider": "磁帶保留容量",
      "disk_slider": "CephFS 快取容量",
      "osdf_disk_slider": "OSDF 快取磁碟",
      "osdf_vcpu_slider": "OSDF 代理節點 vCPU",
      "chart1_title": "五大板塊經費分配環形圖",
      "chart2_title": "算力資源能量對比圖 (VRAM vs CPU 核心)",
      "chart_compute_density": "配置資源能量",
      "table_title": "官方牌價經費支出明細表",
      "table_headers": {
        "item": "項目與規格",
        "rate": "官方單價",
        "alloc": "配置數量",
        "cost": "年度支出",
        "share": "佔比"
      },
      "checklist_title": "國際治理與政策合規性檢核",
      "checklist": {
        "docdb_title": "DocDB 17608 政策合規",
        "docdb_desc": "磁帶 ≤ 1.0 PB 封頂，非觀測期數據定期精簡",
        "ceph_title": "CephFS 熔斷解除",
        "ceph_desc": "磁碟 ≤ 200 TB 快取，解除 79% 儲存熔斷",
        "gpu_title": "GPU 戰略轉型優先 (>65%)",
        "gpu_desc": "攻克 LVK 全球 GPU 荒，產出標誌性科研成果",
        "attrib_title": "Computed at AS 致謝標記",
        "attrib_desc": "專案專用算力明確標註台灣中研院科研貢獻"
      },
      "action_dock": {
        "title": "決策報告導出與配置分享",
        "subtitle": "支援一鍵生成會議決策摘要 Markdown 與機器可讀 JSON"
      },
      "footnotes_title": "經費計費基準與科學治理原則說明",
      "stat_cost_label": "年耗費:",
      "stat_pct_label": "佔總預算:",
      "stat_compute_cost_label": "算力池年耗費:",
      "scales": {
        "tape_docdb": "1,000 TB (DocDB 17608)",
        "disk_rec": "200 TB (推薦快取池)",
        "osdf_base": "10 TB (現存 8.2 TB 基準)",
        "osdf_mirror": "20 TB (完整鏡像)",
        "osdf_mid": "4~8 vCPU (10~40G)",
        "osdf_max": "16 vCPU (100GbE 滿載)",
        "cpu_mid": "1,000 核 (千核門檻)"
      },
      "units": {
        "cores": "核",
        "cards": "卡",
        "cores_count": "核心",
        "cday_unit": "萬核·日/年",
        "per_year": "/ 年",
        "per_day": "/日",
        "balanced_tag": "(已達最佳平衡)"
      },
      "subtotals": {
        "storage": "小計：基礎儲存與快取 (Storage Subtotal)",
        "compute": "小計：核心算力資源池 (Core Compute Subtotal)"
      }
    }
  },
  "en": {
    "system": {
      "title": "KAGRA Budget Allocation & Computing Transformation Decision Platform",
      "subtitle": "Strategic Scientific Infrastructure Investment Model: Academia Sinica Institute of Physics (ASIoP) × ASGC",
      "tagline": "Unlocking 1.0 PB Policy-Compliant Archive and 65%+ Dedicated Gravitational-Wave GPU Compute with an Annual NT$ 1.5M Budget",
      "strategic_declaration": "Led by Prof. Henry Tsz-King Wong at the Institute of Physics, Academia Sinica (ASIoP) in close partnership with the Academia Sinica Grid-computing Centre (ASGC), this platform defines the next-generation computing and data infrastructure for the KAGRA International Collaboration. The annual investment ceiling is strictly established at NT$ 1,500,000 / year (approx. 46,000 USD / year). The strategic transformation embodies 'Storage Rationalization, Compute Acceleration': capping cold storage at 1.0 PB Tape in strict adherence to the new KAGRA Data Retention Policy approved unanimously at the KSC meeting on Oct 29, 2026 (DocDB 17608); consolidating disk storage to a 200 TB high-throughput CephFS scratch cache; deploying a 10~20 TB OSDF Asia-Pacific Caching Hub; and channeling the primary funding (approx. NT$ 980,000, >65%) into project-dedicated GPU high-performance clusters. This directly resolves the acute global GPU shortage across the LVK network, powering groundbreaking scientific discoveries explicitly acknowledged as 'Computed at AS'.",
      "badges": {
        "tape_cap": "1.0 PB Tape Capped",
        "retention_policy": "DocDB 17608 Compliant",
        "disk_cache": "200 TB Scratch Cache",
        "osdf_hub": "OSDF APAC Hub",
        "gpu_priority": "65%+ Dedicated GPU",
        "credit_ack": "'Computed at AS' Attribution"
      }
    },
    "modules": {
      "tape_archive": {
        "id": "tape_archive",
        "name": "Tape Archive Pool",
        "category": "Long-Term Cold Storage",
        "badge": "Policy Compliance & Preservation",
        "pricing_tag": "NT$ 300 / TB / year",
        "description": "Serving as the ultra-reliable bedrock for core scientific observational data, maintaining a guaranteed allocation of 1.0 PB (1,000 TB) tape storage. This framework rigorously aligns with DocDB 17608 (approved at the KSC meeting on Oct 29, 2026): permanently preserving official Observing Periods data while biannually purging transient non-observing commissioning raw data under CSWG oversight, achieving zero-risk cold archiving.",
        "specs_summary": "1,000 TB Guaranteed Quota | NT$ 300,000 / year (20.0% of total)",
        "technical_details": "Enterprise IBM/Spectra LTO tape libraries featuring air-gapped physical data isolation, ransomware immunity, and staged batch recall into CephFS."
      },
      "cephfs_cache": {
        "id": "cephfs_cache",
        "name": "CephFS Working Cache Pool",
        "category": "High-Throughput Scratch Storage",
        "badge": "Dynamic Compute Cache",
        "pricing_tag": "NT$ 1,000 / TB / year",
        "description": "Downscaling disk footprint from historical ~800 TB to an agile 200 TB scratch pool. Re-architected strictly as a high-speed working cache for active GPU/CPU pipelines, permanently eliminating ASGC's 79% CephFS storage-circuit-breaker crisis while delivering sub-millisecond POSIX parallel I/O throughput.",
        "specs_summary": "200 TB High-Speed Scratch | NT$ 200,000 / year (13.3% of total)",
        "technical_details": "Distributed CephFS filesystem natively mounted across all ASGC HPC nodes and Slurm scheduler environments, minimizing cross-node latency."
      },
      "osdf_hub": {
        "id": "osdf_hub",
        "name": "OSDF Asia-Pacific Distribution Hub",
        "category": "Global Scientific Data Federation",
        "badge": "IGWN Intercontinental Relay",
        "pricing_tag": "Disk NT$ 1,000/TB/yr + CPU Tariff",
        "description": "Equipped with 10~20 TB dedicated caching disk and 4~8 vCPUs, functioning as the premier Open Science Data Federation (OSDF) secondary caching relay in the Asia-Pacific. Directly caching Kashiwa campus Origin data (~8.2 TB) to relieve trans-Pacific WAN bandwidth, leveraging an annual cost of only NT$ 10k~23k to unlock massive international collaboration efficiency.",
        "specs_summary": "10~20 TB Cache + 4~8 vCPU | NT$ 11,752 ~ 23,504 / year (~0.8% - 1.6% of total)",
        "technical_details": "Integrated with Pelican / XRootD OSDF proxy protocols, offering seamless interoperation with Open Science Grid (OSG) and ICRR Kashiwa Origin."
      },
      "compute_pool": {
        "id": "compute_pool",
        "name": "GPU / CPU High-Performance Compute Pool",
        "category": "Scientific Analysis Engine",
        "badge": "Core Strategic Driver",
        "pricing_tag": "Dynamic Budget Balancing (~NT$ 980k, >65% share)",
        "description": "The strategic engine of the entire transformation. By reinvesting substantial storage savings into dedicated compute, this tier provisions 10~24 flagship GPUs (A100, L40S, RTX 4090) and 650~1,250 high-performance CPU cores. Instead of anonymous shared queues, compute is dedicated to high-impact science pipelines (e.g., Sawada / RESCEU real-time ML search), mandating 'Computed at AS' attribution.",
        "specs_summary": "Dedicated GPU Cluster + 1,000+ Core CPU Pool | NT$ 976,496 ~ 988,248 / year (>65.1%)",
        "technical_details": "Full support for NVIDIA CUDA 12+, Tensor Core FP16/BF16/FP64, Apptainer/Singularity containerization, and CVMFS software distribution."
      }
    },
    "presets": {
      "preset_1_flagship_gpu": {
        "id": "preset_1",
        "key": "flagship_gpu",
        "name": "Preset 1: Flagship GPU Dedicated",
        "sub_name": "Sawada / RESCEU Real-Time Search Acceleration",
        "tagline": "Uncompromising Tensor & FP64 power dedicated to KAGRA O5 low-latency ML pipelines",
        "target_scenario": "Extreme project dedication. Tailored directly for Prof. Takahiro Sawada (ICRR) and Alvin's team at RESCEU / SPIIR to power real-time machine learning gravitational-wave detection for O5. Delivers targeted relief for LVK's severe GPU shortage, guaranteeing preemptive compute upon alerts to maximize high-impact papers acknowledged as 'Computed at AS'.",
        "highlights": [
          "16 dedicated NVIDIA A100 (80GB) flagship GPUs running full-year",
          "Massive 1,280 GB aggregate high-bandwidth HBM2e memory",
          "Accompanied by 648 AMD EDR2 (Zen 5c) processor cores",
          "Compute investment reaches NT$ 988,248 (65.9% of total budget)"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "10 TB + 4 vCPU EDR2",
          "gpu": "16x NVIDIA A100 (80GB)",
          "cpu": "648 Cores AMD EDR2 (Zen 5c)"
        }
      },
      "preset_2_balanced_flagship": {
        "id": "preset_2",
        "key": "balanced_flagship",
        "name": "Preset 2: Balanced Flagship",
        "sub_name": "Real-Time Inference + Massive 1,000+ Core Offline PE",
        "tagline": "Golden ratio balance bridging low-latency alerting and heavy Bayesian Parameter Estimation",
        "target_scenario": "Comprehensive scientific balance. Deploys 10 persistent A100 (80GB) GPUs for continuous low-latency ML inference, while channeling all remaining budget into a massive 1,250-core AMD EDR2 CPU cluster. Ideal for science consortia handling both alert-generation and heavy offline MCMC parameter estimation (Bilby / LALInference).",
        "highlights": [
          "10x A100 (80GB) GPUs providing 800 GB VRAM for real-time inference",
          "Thousand-core scale: 1,250 high-efficiency AMD Zen 5c CPU cores",
          "Delivers over 456,000 core-days of offline grid capacity annually",
          "100.0% exact budget utilization with zero idle fiscal capital"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "10 TB + 8 vCPU EDR2",
          "gpu": "10x NVIDIA A100 (80GB)",
          "cpu": "1,250 Cores AMD EDR2 (Zen 5c)"
        }
      },
      "preset_3_high_density": {
        "id": "preset_3",
        "key": "high_density",
        "name": "Preset 3: High-Density High-Throughput",
        "sub_name": "Massive L40S / RTX 4090 Concurrency for Multiple Early-Career Groups",
        "tagline": "Exploding accelerator capacity to 24 GPUs for maximum parallel pipeline throughput",
        "target_scenario": "High-concurrency multi-group empowerment. Leveraging Ada Lovelace architecture across 12x L40S (45GB) and 12x RTX 4090 (24GB)—totaling 24 accelerator cards, more than triple ASGC's current baseline! Specifically designed to support early-career researchers nominated by Prof. Kanda (Sakai, Oshino, Marco) and parallel DetChar/CBC analysis.",
        "highlights": [
          "Total 24 modern accelerator GPUs (12x L40S 45GB + 12x RTX 4090 24GB)",
          "Combined 828 GB VRAM supporting concurrent multi-model ML training",
          "Upgraded 20 TB OSDF Asia-Pacific caching hub for minimal WAN latency",
          "949 CPU cores retained for feature extraction and data preprocessing"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "20 TB + 8 vCPU EDR2",
          "gpu": "12x L40S (45GB) + 12x RTX 4090 (24GB)",
          "cpu": "949 Cores AMD EDR2 (Zen 5c)"
        }
      },
      "preset_4_full_stack_package": {
        "id": "preset_4",
        "key": "full_stack_package",
        "name": "Preset 4: Full-Stack Science Package",
        "sub_name": "Hybrid GPUs + 1,170 CPU Cores + 20 TB OSDF Flagship Hub",
        "tagline": "All-in-one regional powerhouse fulfilling complete KAGRA Tier-1 operational expectations",
        "target_scenario": "All-in-one institutional suite. Engineered for Academia Sinica to serve as KAGRA's primary Tier-1 Asia-Pacific Data & Computing Center. Features a full 20 TB OSDF regional cache, 6x A100 (80GB) flagship double-precision cards, 8x L40S (45GB) versatile AI accelerators, and a 1,170-core CPU cluster covering the entire data lifecycle.",
        "highlights": [
          "Heterogeneous GPU pool: 6x A100 (80GB) + 8x L40S (45GB) (840 GB total VRAM)",
          "1,170 AMD EDR2 CPU cores sustaining sustained high-throughput grid tasks",
          "Comprehensive 20 TB OSDF + 8 vCPU APAC hub reducing international WAN loads by 80%",
          "Fully satisfies KAGRA international leadership's highest Tier-1 vision"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "20 TB + 8 vCPU EDR2",
          "gpu": "6x A100 (80GB) + 8x L40S (45GB)",
          "cpu": "1,170 Cores AMD EDR2 (Zen 5c)"
        }
      }
    },
    "hardware_catalog": {
      "storage_tiers": {
        "tape": {
          "name": "LTO Enterprise Tape Library",
          "spec": "High-density cartridges / Air-gapped / Zero-power idle",
          "unit_price_display": "NT$ 300 / TB / year",
          "unit_type": "TB / year",
          "role_desc": "Long-term regulatory archival for official raw observational data"
        },
        "cephfs": {
          "name": "CephFS Distributed Working Storage",
          "spec": "NVMe/SAS hybrid cluster / Full POSIX compatibility",
          "unit_price_display": "NT$ 1,000 / TB / year",
          "unit_type": "TB / year",
          "role_desc": "High-speed scratch space supporting random parallel I/O"
        },
        "osdf_cache": {
          "name": "OSDF Federation Caching Disk",
          "spec": "Dedicated XRootD / Pelican Proxy caching store",
          "unit_price_display": "NT$ 1,000 / TB / year",
          "unit_type": "TB / year",
          "role_desc": "Open Science cross-institutional caching and APAC distribution"
        }
      },
      "gpu_models": {
        "A100": {
          "name": "NVIDIA A100 Tensor Core",
          "vram": "80 GB HBM2e",
          "architecture": "Ampere (Premier HPC Flagship)",
          "rate_daily": "NT$ 120.0 / card-day",
          "rate_yearly": "NT$ 43,800 / card-year",
          "best_for": "FP64 numerical relativity, massive tensor computing, large-scale ML training"
        },
        "L40S": {
          "name": "NVIDIA L40S Accelerator",
          "vram": "45 GB GDDR6 (ECC)",
          "architecture": "Ada Lovelace (Next-Gen Universal Pro)",
          "rate_daily": "NT$ 70.0 / card-day",
          "rate_yearly": "NT$ 25,550 / card-year",
          "best_for": "Gravitational-wave Transformer inference, high-throughput AI pipelines"
        },
        "RTX4090": {
          "name": "NVIDIA GeForce RTX 4090",
          "vram": "24 GB GDDR6X",
          "architecture": "Ada Lovelace (Supreme FP32 Value)",
          "rate_daily": "NT$ 60.0 / card-day",
          "rate_yearly": "NT$ 21,900 / card-year",
          "best_for": "High-throughput single-precision filtering, matched filtering, rapid ML iteration"
        },
        "RTX3090": {
          "name": "NVIDIA GeForce RTX 3090",
          "vram": "24 GB GDDR6X",
          "architecture": "Ampere (Dense Workstation Accelerator)",
          "rate_daily": "NT$ 40.0 / card-day",
          "rate_yearly": "NT$ 14,600 / card-year",
          "best_for": "Low-latency inference pools, feature engineering, small-to-medium ML models"
        },
        "V100": {
          "name": "NVIDIA Tesla V100",
          "vram": "24 GB / 32 GB HBM2",
          "architecture": "Volta (Enterprise Workhorse)",
          "rate_daily": "NT$ 35.0 / card-day",
          "rate_yearly": "NT$ 12,775 / card-year",
          "best_for": "Legacy CUDA pipelines, double-precision numerical integration validation"
        },
        "B6000": {
          "name": "NVIDIA RTX PRO 6000",
          "vram": "96 GB GDDR6 (ECC)",
          "architecture": "Ada Lovelace (Ultra-Large VRAM Pro)",
          "rate_daily": "NT$ 127.0 / card-day",
          "rate_yearly": "NT$ 46,355 / card-year",
          "best_for": "Massive waveform template banks, multi-million state parameter spaces"
        },
        "P100": {
          "name": "NVIDIA Tesla P100",
          "vram": "16 GB HBM2",
          "architecture": "Pascal (Entry Datacenter GPU)",
          "rate_daily": "NT$ 8.0 / card-day",
          "rate_yearly": "NT$ 2,920 / card-year",
          "best_for": "Educational tasks, pipeline syntax verification, lightweight test benches"
        }
      },
      "cpu_models": {
        "EDR2": {
          "name": "AMD EPYC 9645 (Zen 5c)",
          "cores_per_node": "96 Cores / Node",
          "rate_daily": "NT$ 1.2 / core-day",
          "rate_yearly": "NT$ 438.0 / core-year",
          "best_for": "Primary recommendation: supreme energy efficiency for PE and grid search"
        },
        "intel_g4": {
          "name": "Intel Xeon Gold 6448H",
          "cores_per_node": "128 Cores (Sapphire Rapids)",
          "rate_daily": "NT$ 1.4 / core-day",
          "rate_yearly": "NT$ 511.0 / core-year",
          "best_for": "High single-core IPC and Intel MKL vectorized scientific routines"
        },
        "EDR1": {
          "name": "AMD Genoa 9654",
          "cores_per_node": "192 Cores @ 2.4GHz (Zen 4)",
          "rate_daily": "NT$ 1.2 / core-day",
          "rate_yearly": "NT$ 438.0 / core-year",
          "best_for": "Stable enterprise grid cluster, memory-intensive batch processing"
        },
        "HDR1": {
          "name": "AMD Rome 7662",
          "cores_per_node": "128 Cores @ 2.0GHz (Zen 2)",
          "rate_daily": "NT$ 1.0 / core-day",
          "rate_yearly": "NT$ 365.0 / core-year",
          "best_for": "Economical high-throughput offline batch analysis"
        }
      }
    },
    "calculator": {
      "title": "Interactive Budget Actuarial Console",
      "subtitle": "Dynamically adjust storage and compute balances; inspect budget boundaries and resource delivery in real-time",
      "labels": {
        "total_budget": "Total Annual Budget",
        "allocated_budget": "Allocated Expenditure",
        "remaining_balance": "Unallocated Balance",
        "budget_utilization": "Budget Utilization Rate",
        "storage_subtotal": "Base Storage & Cache Cost",
        "compute_subtotal": "Core Compute Expenditure",
        "gpu_share": "GPU Compute Share",
        "cpu_share": "CPU Compute Share",
        "osdf_share": "OSDF Hub Share",
        "tape_quota": "Tape Archive Quota",
        "disk_quota": "CephFS Working Cache",
        "osdf_capacity": "OSDF Cache Disk",
        "osdf_cpu": "OSDF Proxy vCPU",
        "gpu_count": "Total GPU Accelerators",
        "total_vram": "Total VRAM Capacity",
        "cpu_cores": "Total CPU Cores",
        "currency_twd": "New Taiwan Dollar (NTD)",
        "currency_usd": "US Dollar (USD)",
        "currency_jpy": "Japanese Yen (JPY)"
      },
      "status_messages": {
        "optimal": {
          "type": "success",
          "title": "Optimal Allocation",
          "text": "100.0% exact budget execution reached without fiscal surplus or shortfall. Resource allocation is fully optimized."
        },
        "surplus": {
          "type": "info",
          "title": "Surplus Capital Available",
          "text": "Unallocated funds remain. Click 'Auto-fill CPU' or add GPU accelerators to maximize scientific throughput."
        },
        "deficit": {
          "type": "danger",
          "title": "Budget Ceiling Exceeded",
          "text": "Configuration exceeds the NT$ 1,500,000 threshold. Please decrease GPU cards or CPU cores to restore balance."
        },
        "gpu_target_met": {
          "type": "success",
          "title": "Strategic GPU Target Met",
          "text": "GPU funding accounts for over 65% of the budget (~NT$ 980k), perfectly tackling LVK's global GPU shortage."
        },
        "gpu_target_low": {
          "type": "warning",
          "title": "GPU Share Below Strategic Target",
          "text": "GPU allocation is currently below 65%. In accordance with project PI and KAGRA leadership guidance, prioritize GPU expansion."
        },
        "retention_compliant": {
          "type": "success",
          "title": "Fully Compliant with DocDB 17608",
          "text": "Tape capped at 1.0 PB coupled with scheduled non-observing purging resolves ASGC's disk storage crisis."
        }
      },
      "controls": {
        "apply_preset": "Apply Selected Preset",
        "auto_fill_cpu": "Auto-Fill Balance with CPU Cores",
        "reset_defaults": "Reset to Default Config",
        "select_gpu_model": "Select GPU Accelerator Model",
        "select_cpu_model": "Select CPU Architecture",
        "adjust_tape_slider": "Adjust Tape Archive (TB)",
        "adjust_disk_slider": "Adjust CephFS Scratch (TB)",
        "adjust_osdf_slider": "Adjust OSDF Cache (TB)",
        "auto_fill_hint": "Automatically computes the maximum integer CPU cores purchasable with remaining capital."
      }
    },
    "actions": {
      "export_json": "Export Configuration (JSON)",
      "export_summary_md": "Export Decision Brief (Markdown)",
      "copy_share_url": "Copy Shareable Proposal Link",
      "copied_notification": "Proposal link copied to clipboard successfully!",
      "exported_notification": "Configuration file downloaded successfully!",
      "view_methodology": "Review Full Budget Methodology (v9.3)",
      "contact_pi": "Contact Project Leadership (ASIoP / ASGC)"
    },
    "footnotes": {
      "tariff_basis": "Tariff Benchmark: Grounded entirely in the latest official public tariffs published by the National Science and Technology Council Core Facilities (NSTCCore / ASGC, 2026). Bulk reservation discounts may be further negotiated between Prof. Wong and ASGC Director Eric Yen.",
      "retention_policy_basis": "Data Retention Compliance: Capping tape archive at 1.0 PB and disk scratch at 200 TB strictly honors the new KAGRA Data Retention Policy approved unanimously at the KSC meeting on Oct 29, 2026 (DocDB 17608). Only official observing runs are retained indefinitely, while unneeded commissioning data are pruned biannually.",
      "attribution_clause": "Publication Attribution: All gravitational-wave detections, parameter estimations, and detector characterization studies utilizing dedicated AS compute must explicitly state in their acknowledgements: 'Computed at Academia Sinica (AS)', referencing the ASGC computing allocation.",
      "currency_conversion": "Currency Equivalency: The nominal ceiling is NT$ 1,500,000 / year (approx. 46,000 USD or 7,000,000 JPY at current exchange rates). Non-NTD values are for international communication; official settlement occurs strictly in TWD.",
      "binary_capacity_standard": "Capacity Standard: To balance accounting transparency and HPC conventions, storage tariffs follow standard decimal units (1 TB = 10^12 Bytes), while underlying node mounts operate on binary increments (1 TiB = 1024^4 Bytes), with variances strictly bounded within ±2.4%."
    },
    "ui": {
      "presets_heading": "Official Recommended Presets (One-Click)",
      "modules_heading": "Four Core Resource Allocation Modules",
      "analytics_heading": "Real-time Decision Analytics & Governance",
      "kpi_total_compute": "Total Compute Capacity Delivered",
      "kpi_gpu_target": "Strategic Target: >65%",
      "gpu_alloc_heading": "GPU Accelerator Allocations (By Model)",
      "cpu_arch_heading": "Select CPU Processor Architecture",
      "cpu_cores_slider": "Guaranteed CPU Cores",
      "tape_slider": "Tape Retention Quota",
      "disk_slider": "CephFS Working Cache",
      "osdf_disk_slider": "OSDF Cache Disk",
      "osdf_vcpu_slider": "OSDF Proxy Node vCPU",
      "chart1_title": "5-Tier Budget Allocation (Donut)",
      "chart2_title": "Compute Power Comparison (VRAM vs CPU Cores)",
      "chart_compute_density": "Allocated Resource Energy",
      "table_title": "Official Tariffs Expenditure Breakdown Table",
      "table_headers": {
        "item": "Item & Specification",
        "rate": "Tariff Rate",
        "alloc": "Allocated",
        "cost": "Annual Cost",
        "share": "Share"
      },
      "checklist_title": "International Governance & Policy Compliance Checklist",
      "checklist": {
        "docdb_title": "DocDB 17608 Policy Compliance",
        "docdb_desc": "Tape capped at ≤ 1.0 PB; non-observing data pruned",
        "ceph_title": "CephFS Breaker Resolved",
        "ceph_desc": "Disk ≤ 200 TB scratch, resolving 79% capacity breaker",
        "gpu_title": "GPU Strategic Priority (>65%)",
        "gpu_desc": "Overcomes global LVK GPU deficit, enabling signature science",
        "attrib_title": "Attribution: 'Computed at AS'",
        "attrib_desc": "Mandatory credit to Academia Sinica on all compute outputs"
      },
      "action_dock": {
        "title": "Decision Brief Export & Allocation Sharing",
        "subtitle": "One-click export of executive summary Markdown and machine-readable JSON"
      },
      "footnotes_title": "Tariff Benchmarks & Scientific Governance Notes",
      "stat_cost_label": "Annual Cost:",
      "stat_pct_label": "Budget Share:",
      "stat_compute_cost_label": "Compute Pool Cost:",
      "scales": {
        "tape_docdb": "1,000 TB (DocDB 17608)",
        "disk_rec": "200 TB (Recommended Scratch)",
        "osdf_base": "10 TB (8.2 TB Current Baseline)",
        "osdf_mirror": "20 TB (Full Mirror)",
        "osdf_mid": "4~8 vCPU (10~40G)",
        "osdf_max": "16 vCPU (100GbE Line Rate)",
        "cpu_mid": "1,000 Cores (Baseline Threshold)"
      },
      "units": {
        "cores": "Cores",
        "cards": "Cards",
        "cores_count": "Cores",
        "cday_unit": "k core-days/yr",
        "per_year": "/ yr",
        "per_day": "/ day",
        "balanced_tag": "(Optimal / Balanced)"
      },
      "subtotals": {
        "storage": "Subtotal: Base Storage & Scratch Cache",
        "compute": "Subtotal: Core Compute Pool (GPU + CPU)"
      }
    }
  },
  "ja": {
    "system": {
      "title": "KAGRA 予算配分・計算資源転換インタラクティブ意思決定プラットフォーム",
      "subtitle": "台湾・中央研究院物理及研究所 (ASIoP) × 計算グリッドセンター (ASGC) 国際科学インフラ戦略投資モデル",
      "tagline": "年間 150 万台湾元の総予算で、1.0 PB 規約準拠アーカイブと 65% 以上の専有 GPU 重力波計算リソースを実現",
      "strategic_declaration": "本プラットフォームは、台湾・中央研究院物理及研究所（ASIoP）の王子敬（Henry Tsz-King Wong）教授が主導し、計算グリッドセンター（ASGC）と緊密に連携して構築された、KAGRA 国際共同実験のための次世代データ・計算インフラ戦略モデルです。年間総投資予算は 150 万台湾元（約 46,000 米ドル / 約 700 万円）に厳格に設定されています。本転換戦略の核心は「ストレージ負荷の適正化と計算能力の飛躍的強化」です。2026 年 10 月 29 日の KSC オンライン総会で全会一致にて可決された新データ保持ポリシー（DocDB 17608）に基づき、長期保存データを 1.0 PB テープに上限設定（Cap）し、CephFS の容量危機を根本解決。ディスクは 200 TB の高速ワークキャッシュへと集約し、10〜20 TB の OSDF アジア太平洋データ配信ハブを構築します。そして、予算の 65% 以上（約 98 万台湾元）をプロジェクト専有 GPU 高性能クラスタに集中投資することで、LVK 全体の深刻な GPU 不足を解消し、世界トップクラスの科学成果を創出して謝辞に『Computed at AS』を明記します。",
      "badges": {
        "tape_cap": "1.0 PB テープ上限",
        "retention_policy": "DocDB 17608 完全準拠",
        "disk_cache": "200 TB 高速キャッシュ",
        "osdf_hub": "OSDF アジア太平洋ハブ",
        "gpu_priority": "65%+ 専有 GPU 配分",
        "credit_ack": "「Computed at AS」謝辞明記"
      }
    },
    "modules": {
      "tape_archive": {
        "id": "tape_archive",
        "name": "テープアーカイブプール (Tape Archive Pool)",
        "category": "長期コールドストレージ",
        "badge": "ポリシー準拠・永久保存",
        "pricing_tag": "300 元 / TB / 年",
        "description": "KAGRA の基幹観測データを安全に守る堅牢な基盤として、1.0 PB（1,000 TB）のテープ保証枠を厳格に維持します。2026 年 10 月 29 日の KSC 総会で承認された DocDB 17608 ポリシーに完全準拠し、本観測期間（Observing Periods）のデータを永久保存する一方、非観測期の試運転データは CSWG の定期審査を経て整理・削除することで、リスクゼロの長期コールド保管を実現します。",
        "specs_summary": "1,000 TB 保証枠 | 年間 300,000 台湾元（全体比 20.0%）",
        "technical_details": "IBM / Spectra エンタープライズ LTO テープライブラリを採用。エアギャップによる物理的分離で不正アクセスを防止し、CephFS への一括ステージング復元をサポート。"
      },
      "cephfs_cache": {
        "id": "cephfs_cache",
        "name": "CephFS ワークキャッシュプール (CephFS Scratch Pool)",
        "category": "高速ディスク作業領域",
        "badge": "高スループット計算用キャッシュ",
        "pricing_tag": "1,000 元 / TB / 年",
        "description": "ディスクストレージ容量を従来の約 800 TB から 200 TB へと大幅にスリム化。実行中の GPU/CPU パイプライン専用の「純計算ワークキャッシュ」へと位置づけを転換し、ASGC CephFS の使用率 79% サーキットブレーカー危機を完全に解消しながら、極めて高いマイクロ秒クラスの POSIX 並列スループットを提供します。",
        "specs_summary": "200 TB 高速キャッシュ | 年間 200,000 台湾元（全体比 13.3%）",
        "technical_details": "Ceph 分散ストレージ構成。ASGC の HPC 計算ノードおよび Slurm ジョブスケジューラにネイティブマウントされ、ノード間 I/O 遅延を極小化。"
      },
      "osdf_hub": {
        "id": "osdf_hub",
        "name": "OSDF アジア太平洋データ配信ハブ (OSDF APAC Hub)",
        "category": "国際科学データ連携",
        "badge": "IGWN 国際データ中継拠点",
        "pricing_tag": "ディスク 1,000 元/TB/年 ＋ CPU 公定価格",
        "description": "専用キャッシュディスク 10〜20 TB および 4〜8 vCPU プロキシサーバを配備し、Open Science Data Federation (OSDF) のアジア太平洋における中核キャッシュ拠点として機能します。東大柏キャンパスの Origin データ（約 8.2 TB）を直接キャッシュし、太平洋横断回線の負荷を大幅に軽減。わずか年 1〜2 万台湾元程度の極小予算で巨大な国際的相乗効果を生み出します。",
        "specs_summary": "10〜20 TB キャッシュ ＋ 4〜8 vCPU | 年間 11,752 〜 23,504 台湾元（全体比約 0.8% 〜 1.6%）",
        "technical_details": "Pelican / XRootD OSDF プロキシプロトコルを統合し、米国 Open Science Grid (OSG) および東大 ICRR 柏 Origin とシームレスに相互連携。"
      },
      "compute_pool": {
        "id": "compute_pool",
        "name": "GPU / CPU 高性能計算リソースプール (Core Compute Engine)",
        "category": "科学解析計算コア",
        "badge": "戦略的転換の中核エンジン",
        "pricing_tag": "動的予算バランス（約 98 万台湾元、シェア 65% 超）",
        "description": "本転換計画の最重要エンジン。ストレージ合理化によって創出された巨額の予算をプロジェクト専有の計算リソースへと集中投下し、10〜24 枚の最上位 GPU（A100, L40S, RTX 4090）および 650〜1,250 コアの高性能 CPU を常時確保します。匿名共有キューを排し、Sawada / RESCEU リアルタイム探査やパラメータ推定などの特定プロジェクトに専有提供。論文成果には『Computed at AS』の明記を義務付けます。",
        "specs_summary": "専有 GPU クラスタ ＋ 千コア規模 CPU プール | 年間約 976,496 〜 988,248 台湾元（65.1% 超）",
        "technical_details": "NVIDIA CUDA 12+, Tensor Core FP16/BF16/FP64, Apptainer/Singularity コンテナ環境、CVMFS ソフトウェア配信に完全対応。"
      }
    },
    "presets": {
      "preset_1_flagship_gpu": {
        "id": "preset_1",
        "key": "flagship_gpu",
        "name": "プリセット1：フラッグシップ GPU 専有型",
        "sub_name": "Sawada / RESCEU リアルタイム探査加速プロジェクト",
        "tagline": "最上位 Tensor & FP64 性能を全開投入、O5 低遅延機械学習パイプラインを専有加速",
        "target_scenario": "徹底的な特定プロジェクト専有型。東京大学の澤田助教および Alvin 氏らが推進する RESCEU / SPIIR の O5 低遅延リアルタイム機械学習探査パイプラインに特化。LVK 全体で最も深刻な GPU 不足を集中的に解消し、重力波アラート発出時の最優先計算を保証することで、「Computed at AS」の謝辞を冠した世界的成果を創出します。",
        "highlights": [
          "NVIDIA A100 (80GB) 最上位 GPU を 16 枚フルタイム専有配備",
          "大容量 1,280 GB の HBM2e 超高速グラフィックスメモリ総量を確保",
          "最新アーキテクチャの AMD EDR2 (Zen 5c) CPU 648 コアが伴走",
          "計算リソース投資額は 988,248 台湾元（総予算の 65.9%）に達し最大級の存在感"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "10 TB + 4 vCPU EDR2",
          "gpu": "16 枚 NVIDIA A100 (80GB)",
          "cpu": "648 コア AMD EDR2 (Zen 5c)"
        }
      },
      "preset_2_balanced_flagship": {
        "id": "preset_2",
        "key": "balanced_flagship",
        "name": "プリセット2：バランス旗艦型",
        "sub_name": "リアルタイム推論 ＋ 千コア規模オフラインパラメータ推定 (PE)",
        "tagline": "黄金比率のバランス：即時アラート推論と大規模ベイズ推定をハイブリッド両立",
        "target_scenario": "包括的サイエンスバランス型。10 枚の A100 (80GB) を常駐させてリアルタイム低遅延推論を確実に支え、残余予算を極大化して 1,250 コアの高性能 AMD EDR2 CPU を配備。短時間の低遅延探査と、CPU を大量消費する Bilby / LALInference の MCMC パラメータ推定を余すことなくカバーします。",
        "highlights": [
          "10 枚の A100 (80GB) による 800 GB VRAM のリアルタイム推論基盤",
          "千コアの大台突破：1,250 コアの超高能率 AMD Zen 5c CPU",
          "年間 45.6 万 core-days に及ぶ膨大なオフライングリッド解析キャパシティ",
          "予算執行率 100.0% の完全な均衡配分により資金の余剰や無駄を排除"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "10 TB + 8 vCPU EDR2",
          "gpu": "10 枚 NVIDIA A100 (80GB)",
          "cpu": "1,250 コア AMD EDR2 (Zen 5c)"
        }
      },
      "preset_3_high_density": {
        "id": "preset_3",
        "key": "high_density",
        "name": "プリセット3：高密度・高コスパ型",
        "sub_name": "L40S / RTX 4090 大規模並列と複数若手解析チームの同時支援",
        "tagline": "アクセラレータ搭載数を 24 枚へ倍増、圧倒的コストパフォーマンスで並列処理を支援",
        "target_scenario": "高並発マルチチーム型。新世代 Ada Lovelace アーキテクチャの L40S (45GB) 12 枚と RTX 4090 (24GB) 12 枚を組み合わせ、合計 24 枚ものアクセラレータを展開。ASGC の既存対外枠（7 枚）を何倍にも拡大し、神田教授推薦の若手研究者（酒井氏、押野氏、Marco 氏）や複数解析グループの同時並列実行を力強く支えます。",
        "highlights": [
          "合計 24 枚の最新 GPU（L40S 45GB×12 枚 ＋ RTX 4090 24GB×12 枚）を展開",
          "総計 828 GB の VRAM により複数 ML モデルの並列学習を実現",
          "20 TB OSDF アジア太平洋ハブへ増強し国際データ転送を極小遅延化",
          "データ前処理・特徴量エンジニアリング用に 949 コア CPU を保持"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "20 TB + 8 vCPU EDR2",
          "gpu": "12 枚 L40S (45GB) + 12 枚 RTX 4090 (24GB)",
          "cpu": "949 コア AMD EDR2 (Zen 5c)"
        }
      },
      "preset_4_full_stack_package": {
        "id": "preset_4",
        "key": "full_stack_package",
        "name": "プリセット4：フルスタック・サイエンスパッケージ",
        "sub_name": "ハイブリッド GPU ＋ 1,170 コア常駐 ＋ 20 TB OSDF 旗艦ハブ",
        "tagline": "全機能統合型のフラッグシップ構成、KAGRA アジア太平洋中核拠点の最高要件を満たす",
        "target_scenario": "オールインワン拠点型。中央研究院が KAGRA のアジア太平洋中核 Tier-1 拠点としての責務を果たすための完全パッケージ。20 TB OSDF 地域ハブ、6 枚の A100 (80GB) 倍精度フラッグシップカード、8 枚の L40S (45GB) 多目的カード、そして 1,170 コアの大規模 CPU クラスタを備え、データ配信から深層物理解析までを完全網羅します。",
        "highlights": [
          "異種ハイブリッド GPU：A100 (80GB)×6 枚 ＋ L40S (45GB)×8 枚（計 840 GB VRAM）",
          "1,170 コアの AMD EDR2 CPU による長期安定したハイスループット計算力",
          "完全版 20 TB OSDF ＋ 8 vCPU APAC ハブにより国際回線負荷を 80% 削減",
          "KAGRA 国際共同実験が台湾拠点に寄せる最大の期待と信頼に完全応える構成"
        ],
        "resource_breakdown": {
          "tape": "1,000 TB (1.0 PB)",
          "disk": "200 TB CephFS",
          "osdf": "20 TB + 8 vCPU EDR2",
          "gpu": "6 枚 A100 (80GB) + 8 枚 L40S (45GB)",
          "cpu": "1,170 コア AMD EDR2 (Zen 5c)"
        }
      }
    },
    "hardware_catalog": {
      "storage_tiers": {
        "tape": {
          "name": "LTO エンタープライズテープライブラリ",
          "spec": "高密度カートリッジ / エアギャップ隔離 / 待機電力ゼロ保管",
          "unit_price_display": "300 元 / TB / 年",
          "unit_type": "TB / 年",
          "role_desc": "正式観測データの長期保管およびデータ保持ポリシー準拠アーカイブ"
        },
        "cephfs": {
          "name": "CephFS 分散ディスクワークストレージ",
          "spec": "NVMe/SAS ハイブリッド構成 / 完全 POSIX 互換",
          "unit_price_display": "1,000 元 / TB / 年",
          "unit_type": "TB / 年",
          "role_desc": "高並列ランダム I/O に対応した高速ワーク領域および計算キャッシュ"
        },
        "osdf_cache": {
          "name": "OSDF 連合キャッシュディスク",
          "spec": "XRootD / Pelican Proxy 専用バッファストレージ",
          "unit_price_display": "1,000 元 / TB / 年",
          "unit_type": "TB / 年",
          "role_desc": "Open Science 国際データ連携およびアジア太平洋地域への高速配信"
        }
      },
      "gpu_models": {
        "A100": {
          "name": "NVIDIA A100 Tensor Core",
          "vram": "80 GB HBM2e",
          "architecture": "Ampere (最上位 HPC フラッグシップ)",
          "rate_daily": "120.0 元 / 枚・日",
          "rate_yearly": "43,800 元 / 枚・年",
          "best_for": "最高峰の FP64 数値シミュレーション、大規模テンソル計算、巨大 ML モデル訓練"
        },
        "L40S": {
          "name": "NVIDIA L40S Accelerator",
          "vram": "45 GB GDDR6 (ECC)",
          "architecture": "Ada Lovelace (次世代汎用プロフェッショナル)",
          "rate_daily": "70.0 元 / 枚・日",
          "rate_yearly": "25,550 元 / 枚・年",
          "best_for": "重力波 Transformer 推論、ハイスループット機械学習、並行解析パイプライン"
        },
        "RTX4090": {
          "name": "NVIDIA GeForce RTX 4090",
          "vram": "24 GB GDDR6X",
          "architecture": "Ada Lovelace (最高コスパ旗艦カード)",
          "rate_daily": "60.0 元 / 枚・日",
          "rate_yearly": "21,900 元 / 枚・年",
          "best_for": "単精度 FP32 高速計算、リアルタイムマッチドフィルタリング、若手チームの迅速な開発"
        },
        "RTX3090": {
          "name": "NVIDIA GeForce RTX 3090",
          "vram": "24 GB GDDR6X",
          "architecture": "Ampere (高密度ワークステーションカード)",
          "rate_daily": "40.0 元 / 枚・日",
          "rate_yearly": "14,600 元 / 枚・年",
          "best_for": "リアルタイム低遅延推論プール、特徴量抽出、中小型 ML タスク"
        },
        "V100": {
          "name": "NVIDIA Tesla V100",
          "vram": "24 GB / 32 GB HBM2",
          "architecture": "Volta (実績あるエンタープライズカード)",
          "rate_daily": "35.0 元 / 枚・日",
          "rate_yearly": "12,775 元 / 枚・年",
          "best_for": "既存のレガシー CUDA パイプライン、FP64 数値積分検証"
        },
        "B6000": {
          "name": "NVIDIA RTX PRO 6000",
          "vram": "96 GB GDDR6 (ECC)",
          "architecture": "Ada Lovelace (超巨大メモリプロ仕様)",
          "rate_daily": "127.0 元 / 枚・日",
          "rate_yearly": "46,355 元 / 枚・年",
          "best_for": "膨大な波形テンプレートバンク、百万次元規模の多自由度パラメータ空間探査"
        },
        "P100": {
          "name": "NVIDIA Tesla P100",
          "vram": "16 GB HBM2",
          "architecture": "Pascal (エントリークラスデータセンター GPU)",
          "rate_daily": "8.0 元 / 枚・日",
          "rate_yearly": "2,920 元 / 枚・年",
          "best_for": "教育・トレーニング用途、パイプライン構文チェック、軽量テストベンチ"
        }
      },
      "cpu_models": {
        "EDR2": {
          "name": "AMD EPYC 9645 (Zen 5c)",
          "cores_per_node": "96 コア / ノード",
          "rate_daily": "1.2 元 / コア・日",
          "rate_yearly": "438.0 元 / コア・年",
          "best_for": "推奨主力：圧倒的なエネルギー効率、大規模パラメータ推定（PE）およびグリッド探査"
        },
        "intel_g4": {
          "name": "Intel Xeon Gold 6448H",
          "cores_per_node": "128 コア (Sapphire Rapids)",
          "rate_daily": "1.4 元 / コア・日",
          "rate_yearly": "511.0 元 / コア・年",
          "best_for": "強力な単核性能、Intel MKL ベクトル最適化科学技術計算ルーチン"
        },
        "EDR1": {
          "name": "AMD Genoa 9654",
          "cores_per_node": "192 コア @ 2.4GHz (Zen 4)",
          "rate_daily": "1.2 元 / コア・日",
          "rate_yearly": "438.0 元 / コア・年",
          "best_for": "安定した基幹クラスタ、メモリ集約型バッチ解析ジョブ"
        },
        "HDR1": {
          "name": "AMD Rome 7662",
          "cores_per_node": "128 コア @ 2.0GHz (Zen 2)",
          "rate_daily": "1.0 元 / コア・日",
          "rate_yearly": "365.0 元 / コア・年",
          "best_for": "極めて安価な大規模オフラインバッチ処理、優先度の低い長期解析"
        }
      }
    },
    "calculator": {
      "title": "インタラクティブ予算シミュレーション卓",
      "subtitle": "ストレージと計算資源の比率を自在に調整し、予算境界と提供リソース規模をリアルタイム検証",
      "labels": {
        "total_budget": "年間総投資予算",
        "allocated_budget": "配分済み予算合計",
        "remaining_balance": "未配分残額",
        "budget_utilization": "予算執行率",
        "storage_subtotal": "基本ストレージ・キャッシュ費用",
        "compute_subtotal": "中核計算リソース総費用",
        "gpu_share": "GPU 予算割合",
        "cpu_share": "CPU 予算割合",
        "osdf_share": "OSDF キャッシュ割合",
        "tape_quota": "テープアーカイブ容量",
        "disk_quota": "CephFS ワークキャッシュ容量",
        "osdf_capacity": "OSDF キャッシュ容量",
        "osdf_cpu": "OSDF ノード vCPU",
        "gpu_count": "GPU 合計搭載枚数",
        "total_vram": "総 VRAM 容量",
        "cpu_cores": "CPU 合計コア数",
        "currency_twd": "台湾元 (NTD)",
        "currency_usd": "米ドル (USD)",
        "currency_jpy": "日本円 (JPY)"
      },
      "status_messages": {
        "optimal": {
          "type": "success",
          "title": "最適な配分です (Optimal)",
          "text": "予算執行率は完全に 100.0% に達しており、余剰や不足なくリソース配分が極大化されています。"
        },
        "surplus": {
          "type": "info",
          "title": "未配分の予算があります (Surplus Available)",
          "text": "予算に残余があります。「CPU 自動補完」をクリックするか、GPU 枚数を増やして計算能力を最大化してください。"
        },
        "deficit": {
          "type": "danger",
          "title": "予算上限を超過しています (Budget Exceeded)",
          "text": "総額が 1,500,000 台湾元の上限を超過しています。GPU 枚数または CPU コア数を減らして調整してください。"
        },
        "gpu_target_met": {
          "type": "success",
          "title": "GPU 重点転換の目標を達成",
          "text": "GPU 予算割合が総予算の 65% 以上（約 98 万台湾元）に達しており、LVK の GPU 不足を打破する戦略目標に合致します。"
        },
        "gpu_target_low": {
          "type": "warning",
          "title": "GPU 割合の引き上げを推奨",
          "text": "現在の GPU 配分割合が 65% を下回っています。王教授および KAGRA 幹部との合意に基づき、GPU の増強を推奨します。"
        },
        "retention_compliant": {
          "type": "success",
          "title": "DocDB 17608 データ保持ポリシーに完全準拠",
          "text": "テープ 1.0 PB 上限設定と非観測期データの定期削除計画により、ASGC のストレージ危機を解消します。"
        }
      },
      "controls": {
        "apply_preset": "推奨プリセットを適用",
        "auto_fill_cpu": "残余予算で CPU コアを自動補完",
        "reset_defaults": "初期設定にリセット",
        "select_gpu_model": "GPU アクセラレータ型番の選択",
        "select_cpu_model": "CPU アーキテクチャの選択",
        "adjust_tape_slider": "テープアーカイブ容量調整 (TB)",
        "adjust_disk_slider": "CephFS ワークキャッシュ容量調整 (TB)",
        "adjust_osdf_slider": "OSDF キャッシュ容量調整 (TB)",
        "auto_fill_hint": "残余資金で購入可能な最大整数の CPU コア数を自動計算して割り当てます。"
      }
    },
    "actions": {
      "export_json": "構成データ出力 (JSON)",
      "export_summary_md": "意思決定サマリー出力 (Markdown)",
      "copy_share_url": "共有リンクをコピー",
      "copied_notification": "共有リンクをクリップボードにコピーしました！",
      "exported_notification": "設定ファイルを正常にダウンロードしました！",
      "view_methodology": "予算方法論 (v9.3) を確認",
      "contact_pi": "プロジェクト窓口 (ASIoP / ASGC) に連絡"
    },
    "footnotes": {
      "tariff_basis": "料金基準の根拠：台湾・国家科学技術委員会コアファシリティ（NSTCCore / ASGC）が 2026 年に公表した最新の公式標準料金に厳格に基づいています。大口事前予約割引については、王教授と ASGC 厳漢偉主任の間で協議が可能です。",
      "retention_policy_basis": "データ保持ポリシー準拠：テープ 1.0 PB 上限および 200 TB キャッシュ構成は、2026 年 10 月 29 日の KAGRA 科学協力組織（KSC）総会で全会一致可決された新データ保持ポリシー（DocDB 17608）に完全準拠しています。正式な観測データのみを永久保存し、非観測期の不要データは半年毎の CSWG 承認リストに基づき安全に削除されます。",
      "attribution_clause": "学術成果の謝辞表記義務：本専有計算リソース（GPU/CPU）を用いて創出された重力波探査、パラメータ推定、検出器特徴付け（DetChar）の全論文において、謝辞に『Computed at Academia Sinica (AS)』を明記し、ASGC の計算資源助成番号を引用することが義務付けられます。",
      "currency_conversion": "通貨換算に関する注記：基準予算は年間 1,500,000 台湾元（NTD）です。参考として約 46,000 米ドル（USD）または約 700 万円（JPY）に相当しますが、国際間コミュニケーション用であり、実際の契約・精算はすべて台湾元で行われます。",
      "binary_capacity_standard": "容量規格の定義：会計上の透明性と計算機環境の実態を両立させるため、公式料金計算では十進法（1 TB = 10^12 バイト）を採用し、計算ノード上のマウント等では二進法（1 TiB = 1024^4 バイト）を使用します。両者の差は ±2.4% の許容誤差内に収まります。"
    },
    "ui": {
      "presets_heading": "公式推奨プリセット（ワンクリック適用）",
      "modules_heading": "4大中核リソース動的配分モジュール",
      "analytics_heading": "意思決定ダッシュボード＆ガバナンス検証",
      "kpi_total_compute": "総計算性能提供仕様",
      "kpi_gpu_target": "戦略目標: >65%",
      "gpu_alloc_heading": "GPU 加速カード配分（モデル別独立設定）",
      "cpu_arch_heading": "CPU アーキテクチャ選択",
      "cpu_cores_slider": "CPU 保証計算コア数",
      "tape_slider": "テープ保管容量",
      "disk_slider": "CephFS キャッシュ容量",
      "osdf_disk_slider": "OSDF キャッシュ容量",
      "osdf_vcpu_slider": "OSDF ノード vCPU",
      "chart1_title": "5大項目予算配分ドーナツグラフ",
      "chart2_title": "計算リソース比較（VRAM vs CPU コア）",
      "chart_compute_density": "配分リソースエネルギー",
      "table_title": "公定価格に基づく年間支出明細表",
      "table_headers": {
        "item": "項目・仕様",
        "rate": "公式単価",
        "alloc": "配分量",
        "cost": "年間費用",
        "share": "割合"
      },
      "checklist_title": "国際ガバナンス・ポリシー準拠チェック",
      "checklist": {
        "docdb_title": "DocDB 17608 ポリシー準拠",
        "docdb_desc": "テープ上限 1.0 PB、非観測期データ定期削減",
        "ceph_title": "CephFS サーキットブレーカー解除",
        "ceph_desc": "キャッシュ ≤ 200 TB、79% 枯渇リスク解消",
        "gpu_title": "GPU 戦略シフト優先 (>65%)",
        "gpu_desc": "LVK 世界的 GPU 不足に対処、画期的成果を創出",
        "attrib_title": "謝辞表記：「Computed at AS」",
        "attrib_desc": "専有計算リソースに台湾中央研究院の貢献を明記"
      },
      "action_dock": {
        "title": "意思決定レポート出力＆設定共有",
        "subtitle": "ワンクリックで会議用サマリー (Markdown) と機械可読 JSON を出力"
      },
      "footnotes_title": "算定基準および科学ガバナンス原則に関する注記",
      "stat_cost_label": "年間費用:",
      "stat_pct_label": "予算比率:",
      "stat_compute_cost_label": "計算プール年間費用:",
      "scales": {
        "tape_docdb": "1,000 TB (DocDB 17608)",
        "disk_rec": "200 TB (推奨キャッシュ)",
        "osdf_base": "10 TB (現状 8.2 TB 基準)",
        "osdf_mirror": "20 TB (完全ミラー)",
        "osdf_mid": "4~8 vCPU (10~40G)",
        "osdf_max": "16 vCPU (100GbE 帯域上限)",
        "cpu_mid": "1,000 コア (基準ライン)"
      },
      "units": {
        "cores": "コア",
        "cards": "枚",
        "cores_count": "コア",
        "cday_unit": "万コア・日/年",
        "per_year": "/ 年",
        "per_day": "/ 日",
        "balanced_tag": "(最適上限達成 / Balanced)"
      },
      "subtotals": {
        "storage": "小計：基礎ストレージ・キャッシュ",
        "compute": "小計：中核計算リソースプール (GPU + CPU)"
      }
    }
  }
}